import {isObject} from 'lodash';

const utils = require('public/js/helpers/utils');

const getVehiclePicker = () => import(/* webpackChunkName: "get-vehicle-picker" */ 'public/js/components/vehicle-picker.js');

// A list of classes used to open the vehicle picker
const vehiclePickerSelector = [
	'.vehiclepicker_classic',
	'.vehiclepicker',
	'.vehiclepicker_link',
	'.vehiclepicker-link',
].join(', ');

const browseCatalogAnchorSelector = '[data-vehicle-dropdown-data="browse-catalog"]';
const selectVehicleSubmitSelector = 'a.js-vpicker-select-vehicle';

const isJavaScriptHref = (href) => {
	const h = href?.trim() ?? '';
	return h === '' || h.toLowerCase().startsWith('javascript:');
};

const handleOpenVehiclePicker = ({ currentTarget }, props = null) => {
	const pickerData = props || currentTarget?.dataset;
	if (!pickerData) return;
	getVehiclePicker().then((module) => {
		module.getDataAndOpenVehiclePicker(pickerData);
	});
};

// Delegated click so elements added after load also work
document.addEventListener('click', (e) => {
	const clickTarget = e.target instanceof Element ? e.target : e.target.parentElement;
	if (clickTarget !== null && clickTarget.closest(browseCatalogAnchorSelector) !== null) {
		return;
	}
	const selectVehicleAnchor = clickTarget?.closest(selectVehicleSubmitSelector);
	if (selectVehicleAnchor) {
		utils.applyWrapperHref(selectVehicleAnchor);
		const rawHref = selectVehicleAnchor.getAttribute('href');
		if (!isJavaScriptHref(rawHref)) {
			return;
		}
	}
	const el = clickTarget?.closest(vehiclePickerSelector);
	if (!el) return;
	e.preventDefault();
	e.stopPropagation();
	handleOpenVehiclePicker({ currentTarget: el }, null);
}, true);

// Moved this out from the vehicle picker js file to account for scenarios where this is called from custom html modules
window.openVehiclePicker = window.openVehiclePickerRedirect = (make, model = null, year = null, trim = null, engine = null, redirect = null) => {
	if (isObject(make)) {
		const { makeInfo, model, year, trim, engine, redirect } = make;
		handleOpenVehiclePicker({}, {makeInfo, model, year, trim, engine, redirect});
	} else {
		handleOpenVehiclePicker({}, {make, model, year, trim, engine, redirect});
	}
};
